import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'

@Component({
  selector: 'app-incomming-chips-label',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './incomming-chips-label.component.html',
  styleUrl: './incomming-chips-label.component.sass',
})
export class IncommingChipsLabelComponent implements OnChanges {
  @Input() show: boolean
  @Input() useEarnClass: boolean
  @Input() chips = 0

  @Output() onClose = new EventEmitter()

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show']?.currentValue === true) {
      setTimeout(() => {
        this.show = false
        this.onClose.emit()
      }, 3000)
    }
  }
}
